/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.countries.internal

import features.countries.models.Countries
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.countries.internal.CountriesUseCase.Params

internal class CountriesUseCase : AsyncUseCase<Countries, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,

    )

    private val countriesService: CountriesService = CountriesServiceImpl()

    override suspend fun run(params: Params): Result<Countries> {
        return countriesService.getCountries(
            overrideHeaders = params.overrideHeaders,

        )
    }
}
